import { IQuoteFull } from "../interface/stock/quote";

// @TODO: maybe it's better to use a queue(FIFO) with limited number of elements
export class RollingData {

    protected startIndex:number|null = null;
    protected endIndex:number|null = null;


    protected highMinsLowSum = 0;

    // rolling sum
    protected returnRateSum = 0;
    protected returnRateSquareDiffSums = 0;

    protected gainSum = 0;
    protected loosesSum = 0;

    protected closeSum = 0;


    protected totalCount = 0;


    /**
     *
     * @param maxSize  how many latest points to aggreate (keep track)
     */
    constructor(protected maxSize: number) {

    }

    add(i: number, stockStats: Readonly<IQuoteFull[]>) {
        if (this.startIndex===null) {
            this.startIndex = i;
            // this.endIndex = i;
        }

        this.totalCount+=1;
        this.endIndex = i;

        const currP = stockStats[i];
        const prevP = stockStats?.[i-1];

        this.closeSum += currP.c;
        this.highMinsLowSum += (currP.h - currP.l);

        // @TODO: maybe don't use "0" as workaround to count only "valid" points
        const returnRate = (RollingData.returnRate(i, stockStats)) || 0;
        this.returnRateSum += returnRate;
        this.returnRateSquareDiffSums += Math.pow(returnRate - (this.returnRateSum/this.totalCount), 2);

        const delta = prevP?.c ? (currP.c - prevP?.c) : 0;
        if (delta > 0) {
            this.gainSum += delta;
        } else if (delta < 0) {
            this.loosesSum += -delta;
        }


        // substract "first" (the oldest point from rolling sums)
        if (this.totalCount > this.maxSize) {
            const firstP = stockStats[this.startIndex];
            const beforeFirstP = stockStats?.[this.startIndex - 1];
            this.closeSum -= firstP.c;
            this.highMinsLowSum -= (firstP.h - firstP.l);

            const retRateFirst = (RollingData.returnRate(this.startIndex, stockStats) || 0);
            this.returnRateSum -= retRateFirst;
            this.returnRateSquareDiffSums -= Math.pow(retRateFirst - (this.returnRateSum/this.totalCount), 2);

            const deltaFirst = beforeFirstP?.c ? (firstP.c - beforeFirstP?.c) : 0;
            if (deltaFirst > 0) {
                this.gainSum -= delta;
            } else if (deltaFirst < 0) {
                this.loosesSum -= -delta;
            }

            this.totalCount-=1;
            this.startIndex++;
        }
    }

    public static returnRate(i: number, stockStats: Readonly<IQuoteFull[]>) {
        const prevClosePrice = stockStats?.[i - 1]?.c;
        const currClosePrice = stockStats[i].c;
        const returnRate = prevClosePrice && currClosePrice ?
                (currClosePrice - prevClosePrice) / prevClosePrice : undefined;
        return returnRate;
    }

    currMeanClose() {
        if (!this.totalCount) {
            return undefined;
        }
        return this.closeSum / this.totalCount;
    }

    currVolatilityClose() {
        if (!this.totalCount) {
            return undefined;
        }
        return Math.sqrt(this.returnRateSquareDiffSums / this.totalCount);
    }

    currRsiClose() {
        if (!this.totalCount) {
            return undefined;
        }
        const avgGain = this.gainSum / this.totalCount;
        const avgLoss = this.loosesSum / this.totalCount;
        if (avgGain === 0) {
            return 0;
        } else if (avgLoss === 0) {
            return 100;
        }
        const rs = avgGain / avgLoss;
        return 100 - (100 / (1 + rs));
    }

    // currMeanReturnRate() {
    //     if (!this.totalCount) {
    //         return undefined;
    //     }
    //     return this.returnRateSum / this.totalCount;
    // }

    currAtr() {
        return this.highMinsLowSum / this.totalCount;
    }


}